import { useState, useEffect } from "react";
import { X, ShieldCheck } from "lucide-react";

const ITEMS = [
  "UK GDPR Compliant",
  "Botswana Data Protection Act",
  "We never sell your data",
  "£0 property commission",
  "Not a bank or immigration authority",
];

export function TrustBar() {
  const [show, setShow] = useState(false);
  useEffect(() => { setShow(localStorage.getItem("pula_trustbar_dismissed") !== "1"); }, []);
  if (!show) return null;
  return (
    <div className="bg-pula-green text-white text-xs font-body" data-testid="trust-bar">
      <div className="max-w-7xl mx-auto px-4 py-1.5 flex items-center justify-center gap-x-4 gap-y-1 flex-wrap relative">
        {ITEMS.map((t) => (
          <span key={t} className="inline-flex items-center gap-1"><ShieldCheck className="w-3 h-3" /> {t}</span>
        ))}
        <button data-testid="trust-bar-dismiss" aria-label="Dismiss"
          onClick={() => { setShow(false); localStorage.setItem("pula_trustbar_dismissed", "1"); }}
          className="absolute right-3 top-1/2 -translate-y-1/2 p-0.5 rounded hover:bg-white/20"><X className="w-3.5 h-3.5" /></button>
      </div>
    </div>
  );
}

export function TrustBarBottom() {
  return (
    <div className="bg-pula-ink text-white/85 text-xs font-body" data-testid="trust-bar-bottom">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-x-4 gap-y-1 flex-wrap">
        {ITEMS.map((t) => (
          <span key={t} className="inline-flex items-center gap-1"><ShieldCheck className="w-3 h-3 text-pula-green" /> {t}</span>
        ))}
      </div>
    </div>
  );
}
